/** @format */

import React, { useEffect, useState } from "react";
import moment from "moment";
import { Box } from "@chakra-ui/react";
import { useRecomendacao } from "../../context/useRecomendacao";
import { FiltrosItem } from "../../components/FiltrosItem";
import { useLocation } from "react-router-dom";
import { formatRecomendacao } from "../../utils";
import { usePersonalizacao } from "../../context/usePersonalizacao";
import { useParams } from "react-router-dom";

export function FiltrosList() {
  const {
    filtros: tipos,
    selectedFiltros,
    addSelectedFilters,
    recomendacao,
  } = useRecomendacao();
  const location = useLocation();
  const { idtiporecomendacao } = useParams();
  const {
    personalizacao: { guiaofertas },
  } = usePersonalizacao();

  const [temporaryFiltros, setTemporaryFiltros] = useState([]);
  const { destaques, ofertas, descontoExclusivo, dinheiroDeVolta } =
    formatRecomendacao(recomendacao, guiaofertas?.hasDestaques);

  useEffect(() => {
    setTemporaryFiltros([...selectedFiltros]);
  }, [selectedFiltros, location.pathname]);

  const handleSubmit = async () => {
    console.log(temporaryFiltros);
    await addSelectedFilters({ filtros: temporaryFiltros });
  };

  const addFilter = ({ tipo }) => {
    const newSelectedFiltros = temporaryFiltros;
    const check = newSelectedFiltros.every((data) => {
      return tipo.id !== data.id;
    });
    if (check) {
      selectedFiltros.filter((data) => {
        return tipo.id === data.id;
      });
      temporaryFiltros.push(tipo);
      setTemporaryFiltros([...newSelectedFiltros]);
    } else {
      temporaryFiltros.forEach((item, index) => {
        if (item.id === tipo.id) {
          temporaryFiltros.splice(index, 1);
        }
      });
      setTemporaryFiltros([...newSelectedFiltros]);
    }
  };

  const verificaFiltroAtivo = (data) => {
    if (temporaryFiltros.filter((filtros) => filtros.id === data.id)[0]) {
      return true;
    } else {
      return false;
    }
  };

  const verificaTipoASerExibido = () => {
    let tiposSerExibido = tipos;

    let pathname = location.pathname.split("/")[1];

    if (
      ofertas.length === 0 &&
      destaques.filter((data) => data.idtiporecomendacao === "2").length === 0
    ) {
      const filter = tiposSerExibido.filter(
        (data) => data.idtiporecomendacao !== "2",
      );
      tiposSerExibido = filter;
    }
    if (
      descontoExclusivo.length === 0 &&
      destaques.filter((data) => data.idtiporecomendacao === "1").length === 0
    ) {
      const filter = tiposSerExibido.filter(
        (data) => data.idtiporecomendacao !== "1",
      );
      tiposSerExibido = filter;
    }
    if (
      dinheiroDeVolta.length === 0 &&
      destaques.filter((data) => data.idtiporecomendacao === "3").length === 0
    ) {
      const filter = tiposSerExibido.filter(
        (data) => data.idtiporecomendacao !== "3",
      );
      tiposSerExibido = filter;
    }
    if (
      recomendacao.filter((data) => data.id_classificacao_topete === "1")
        .length === 0
    ) {
      const filter = tiposSerExibido.filter(
        (data) => data.id_classificacao_topete !== "1",
      );
      tiposSerExibido = filter;
    }
    if (
      recomendacao.filter((data) => data.id_classificacao_topete === "2")
        .length === 0
    ) {
      const filter = tiposSerExibido.filter(
        (data) => data.id_classificacao_topete !== "2",
      );
      tiposSerExibido = filter;
    }
    if (recomendacao.filter((data) => data.clube).length === 0) {
      const filter = tiposSerExibido.filter((data) => data.clube !== true);
      tiposSerExibido = filter;
    }
    if (pathname !== "vermais") {
      const filter = tiposSerExibido.filter((data) => data.ativado !== true);
      tiposSerExibido = filter;
    }
    if (idtiporecomendacao !== "4" && idtiporecomendacao !== "1") {
      const filter = tiposSerExibido.filter((data) => data.ativado !== true);
      tiposSerExibido = filter;
    }
    if (pathname === "vermais") {
      if (idtiporecomendacao === "4") {
        const filter = tiposSerExibido.filter(
          (data) => data.id_classificacao_topete !== "1",
        );

        tiposSerExibido = filter;
      } else {
        const filter = tiposSerExibido.filter(
          (data) => !data.idtiporecomendacao,
        );
        tiposSerExibido = filter;
      }
      if (idtiporecomendacao !== "4" && guiaofertas?.hasDestaques === true) {
        const filter = tiposSerExibido.filter(
          (data) => data.id_classificacao_topete !== "1",
        );
        tiposSerExibido = filter;
      }
    }

    const expiraEmSeteValida = recomendacao.filter((data) => {
      let dataAtual = moment(
        new Date().toLocaleDateString("pt-BR", { timeZone: "UTC" }),
        "DD/MM/YYYY",
      );
      let validadeate = moment(
        new Date(data.validadeate).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
        }),
        "DD/MM/YYYY",
      );

      let diff = moment(validadeate, "DD/MM/YYYY").diff(
        dataAtual,
        "DD/MM/YYYY",
      );
      let diffInDays = moment.duration(diff).asDays();

      if (diffInDays <= 7) {
        return data;
      } else {
        return null;
      }
    });

    if (expiraEmSeteValida.length === 0) {
      const filter = tiposSerExibido.filter((data) => !data.expira);
      tiposSerExibido = filter;
    }

    return tiposSerExibido;
  };

  let pathname = location.pathname.split("/")[1];

  return (
    <Box
      maxWidth="900px"
      w="100%"
      display="flex"
      alignItems="center"
      justifyContent={{ sm: "flex-start", lg: "center" }}>
      <Box whiteSpace="nowrap" overflowX="scroll" px="1rem">
        {verificaTipoASerExibido().map((data, index) => {
          return (
            <FiltrosItem
              key={index}
              label={data.label}
              onClick={() => {
                addFilter({
                  tipo:
                    pathname === ""
                      ? { ...data, isHome: true }
                      : { ...data, isHome: false },
                });
                setTimeout(() => {
                  handleSubmit();
                }, 100);
              }}
              isSelected={verificaFiltroAtivo(data)}
            />
          );
        })}
      </Box>
    </Box>
  );
}
